<p>
    <img src="./assets/temporals/warning.png" alt="">
</p>
<p>
    {{data.text}}
</p>
<div class="btn-container">
    <button type="submit" (click)="closeModal()" id="closeWarningLogin" class="button">Aceptar</button>
</div>